import { render, staticRenderFns } from "./ListCoverTimebarred.vue?vue&type=template&id=205fb3fc"
import script from "./ListCoverTimebarred.vue?vue&type=script&lang=js"
export * from "./ListCoverTimebarred.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports